/* istanbul ignore file */
/**
 * Copyright Warner Bros. Entertainment, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property
 * of Warner Bros. Entertainment, Inc. and its suppliers, if any.
 * The intellectual and technical concepts contained herein are
 * proprietary to Warner Bros. Entertainment, Inc. and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in process,
 * and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is
 * unlawful and strictly forbidden unless prior written permission is
 * obtained from Warner Bros. Entertainment, Inc.
 */

import LookupActions from '../lookup-actions';

const CONSTANTS = {
    GET: {
        ERROR: 'currency_actions.get.error',
        START: 'currency_actions.get.start',
        SUCCESS: 'currency_actions.get.success'
    },
    MESSAGES: {
        CREATE_ERROR: 'lookups.currency.create.error',
        CREATE_OK: 'lookups.currency.create.ok',
        REMOVE_ERROR: 'lookups.currency.remove.error',
        REMOVE_OK: 'lookups.currency.remove.ok',
        SAVE_ERROR: 'lookups.currency.save.error',
        SAVE_OK: 'lookups.currency.save.ok',
    },
    REMOVE_OK: 'currency_actions.remove',
    SAVE_OK: 'currency_actions.save'
};

class CurrencyActions extends LookupActions {

    constructor(path, CONSTS) {
        super(path, CONSTS);
    }

}

let actions = new CurrencyActions('lookup/currency', CONSTANTS);

export {
    actions as CurrencyActions,
    CONSTANTS as CurrencyConstants
};
